// 封装reques请求
import axios from "axios";
import store from "@/store"; // 引入 vuex
import { ElMessage, ElMessageBox } from "element-plus";

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 20000, // 超时时间
});

// 添加request拦截器
service.interceptors.request.use(
  (config: any) => {
    const state: any = store.state;

    config.headers["Authorization"] = "Bearer " + state.auth.token; // 让每个请求携带自定义token 请根据实际情况自行修改

    config.baseURL = process.env?.VUE_APP_BASE_URL || ""; // 获取token 重构访问地址
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

//添加response拦截器
service.interceptors.response.use(
  // response.status为200
  (response) => {
    if (response.data.code) {
      switch (response.data.code) {
        case 2000:
          if (response.headers.authorization) {
            store.commit("setToken", response.headers.authorization);
          }
          return response.data;
        default:
          ElMessage.error(response.data.msg);
          return Promise.reject(response.data.msg);
      }
    } else {
      return response;
    }
  },
  // response.status不为200
  (error) => {
    switch (error.response.status) {
      case 401:
        ElMessageBox.confirm("登录信息过期,请重新登录", "提示", {
          showClose: false,
          confirmButtonText: "确定",
          showCancelButton: false,
          closeOnClickModal: false,
        }).then(() => {
          store.commit("resetState");
          window.location.href = process.env?.VUE_APP_WEB_SSO_URL || "";
        });
        break;
      case 403:
        ElMessage.error("资源权限不足!");
        break;
      default:
        ElMessage.error(error.response.data.error);
    }
    return Promise.reject(error.response);
  }
);

export default service;
